import { jsPDF } from 'jspdf';
import 'svg2pdf.js';
import type { Editor, TLShapeId } from 'tldraw';

export type ExportKind = 'pdf' | 'png' | 'svg';
export type ExportScope = 'page' | 'selection';

function slugify(s: string): string {
  return (
    s
      .trim()
      .toLowerCase()
      .replace(/[^\w\d\u0400-\u04ff-]+/g, '-')
      .replace(/^-|-$/g, '') || 'board'
  );
}

function download(url: string, filename: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export async function exportBoard(
  editor: Editor,
  kind: ExportKind,
  scope: ExportScope,
  baseName: string,
): Promise<void> {
  const ids: TLShapeId[] =
    scope === 'selection'
      ? [...editor.getSelectedShapeIds()]
      : [...editor.getCurrentPageShapeIds()];

  if (ids.length === 0) {
    alert(
      scope === 'selection'
        ? 'Ничего не выделено для экспорта.'
        : 'На доске пока нет фигур.',
    );
    return;
  }

  const name = slugify(baseName);

  if (kind === 'pdf') {
    const result = await editor.getSvgElement(ids, { background: true, padding: 16 });
    if (!result) {
      alert('Не удалось получить SVG для экспорта.');
      return;
    }
    const { svg, width, height } = result;
    const orientation: 'p' | 'l' = width >= height ? 'l' : 'p';
    const pdf = new jsPDF({ orientation, unit: 'px', format: [width, height] });
    await pdf.svg(svg, { x: 0, y: 0, width, height });
    pdf.save(`${name}.pdf`);
    return;
  }

  const image = await editor.toImage(ids, {
    format: kind,
    background: true,
    padding: 16,
    scale: kind === 'png' ? 2 : 1,
  });
  const url = URL.createObjectURL(image.blob);
  try {
    download(url, `${name}.${kind}`);
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
